import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

const defaultPageSize = localStorage.getItem("invoices_pageSize_default")
	? localStorage.getItem("invoices_pageSize_default")
	: process.env.REACT_APP_DEFAULT_PAGE_SIZE_LIST_INVOICE;

export const initialFilter = {
	searchBy: "",
	status: [],
	startIssueDate: null,
	startSaveDate: null,
	startCreatedDate: null,
	endIssueDate: null,
	endSaveDate: null,
	endCreatedDate: null,
	pageNo: 0,
	pageSize: defaultPageSize,
	selectAll: false,
	sortBy: "",
	period: "",
	dashboardStart: moment('2019-10-10').format("YYYY-MM-DD"),
    dashboardEnd: moment().format("YYYY-MM-DD")
};
const filterListInvoices = createSlice({
	name: "filter",
	initialState: initialFilter,
	reducers: {
		updateFilter: (state, action) => ({
            dashboardStart: state.dashboardStart,
            dashboardEnd: state.dashboardEnd,
            ...action.payload
        }),
		initFilter: () => initialFilter,
		updateDashboardDate: (state, action) => {
            state.dashboardStart = action.payload.start;
            state.dashboardEnd = action.payload.end;
        }
	},
});

export const { updateFilter, initFilter, updateDashboardDate } = filterListInvoices.actions;

export default filterListInvoices.reducer;
